import TrialsArea from "@/components/TrialsArea"
import FavouritesContext from "@/contexts/data/FavouritesContext"
import TrialsContext from "@/contexts/data/TrialsContext"
import { Typography, styled } from "@mui/material"
import { useContext, useEffect } from "react"


const NoTrialHeading = styled(Typography)(({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontWeight: 400
}))

const TrialsPage = () => {

    const { data: trials } = useContext(TrialsContext)
    //const {data: favourites, loading: loading} = useGetFavourites();
    const {data: favourites, loading, refresh: refreshFavourites} = useContext(FavouritesContext);

    // this is because the trials change every time the institution changes, and every time the institution changes the 
    // favourites local state in trials area is reset, so we need to refresh the favourites every time the trials change
    // so that the initial displayed are the correct new ones and not the old ones
    useEffect(() => {
        refreshFavourites();
    }, [trials])

    return (
        <>
            {
                (trials && trials.length > 0 && !loading) && (
                    <TrialsArea
                        trials={trials}
                        initialFavourites={favourites}
                    />
                )
            }
            {
                (!trials || trials.length == 0 || loading) && (
                    <NoTrialHeading
                        variant="h2"
                    >
                        No trials to display
                    </NoTrialHeading>
                )
            }
        </>
    )
}

export default TrialsPage
